import { render, staticRenderFns } from "./ui-configuration-card.vue?vue&type=template&id=23d71760&scoped=true"
import script from "./ui-configuration-card.vue?vue&type=script&lang=js"
export * from "./ui-configuration-card.vue?vue&type=script&lang=js"
import style0 from "./ui-configuration-card.vue?vue&type=style&index=0&id=23d71760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d71760",
  null
  
)

export default component.exports